import React, { Fragment as _, useContext } from 'react';
import { Box } from 'theme-ui';

const AssessmentQuestion = ({ children, ...props }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'lime',
      }}
    >
      <h1>Assessment Question</h1>
    </Box>
  );
};

export default AssessmentQuestion;
